import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-felix-oliver-old',
  templateUrl: './about-felix-oliver-old.component.html',
  styleUrls: ['./about-felix-oliver-old.component.scss']
})
export class AboutFelixOliverOldComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
